export const version = "1.7.17-daily-20260814-0";
export const channel = "daily";
export const gitcommit = "c59ca1a38";
